export enum RegistrationStatus {
    unknown,
    closedRegistration,
    closedCheckIn,
    closedJoin,
    awaitCheckIn,
    awaitRegistration,
    allowCheckIn,
    checkedIn
}